import { MODAL_CLEAR, MODAL_CLOSED, MODAL_OPENED } from "../actions/type";

const initialState = {
  openModals: 0, // Number of currently open modals
};

function modalReducer(state = initialState, action) {
  const { type, } = action;
  switch (type) {
    case MODAL_OPENED:
        return {
          ...state,
          openModals: state.openModals + 1,
        };
    case MODAL_CLOSED:
        return {
        ...state,
        openModals: state.openModals > 0 ? state.openModals - 1 : 0,
        };
    case MODAL_CLEAR:
        return {
        ...state,
        openModals: 0,
        };
    default:
      return state;
  }
}

export default modalReducer;